import amplitude from 'amplitude-js';
import { HostPlatform } from '../config/hostPlatform';
import { getTenantId, getUserId } from '../services/firebaseInit';

const API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;
const GROUP_TYPE = 'Tenant';

let initPromise;

const getIdentifiers = async () => {
  const hostPlatform = HostPlatform.get();
  const userId = getUserId();
  const tenantId = getTenantId();

  if (!userId || !tenantId)
    throw new Error(
      "Can't initialize tracking: user ID or tenant ID not found."
    );

  return {
    user: {
      id: userId,
      properties: {
        platform: hostPlatform.id,
        deploymentType: hostPlatform.context.type,
      },
    },
    account: {
      id: tenantId,
      properties: {
        platform: hostPlatform.id,
        deploymentType: hostPlatform.context.type,
        slug: hostPlatform.context.slug,
      },
    },
  };
};

const createIdentifyEvent = (properties) => {
  let identify = new amplitude.Identify();

  for (const [key, value] of Object.entries(properties)) {
    identify = identify.set(key, value);
  }
  return identify;
};

const initTracking = async () => {
  initPromise = getIdentifiers();
  const identifiers = await initPromise;
  amplitude.getInstance().init(API_KEY, identifiers.user.id);
  amplitude.getInstance().setUserProperties(identifiers.user.properties);
  amplitude.getInstance().setGroup('Tenant', identifiers.account.id);
  amplitude
    .getInstance()
    .groupIdentify(
      GROUP_TYPE,
      identifiers.account.id,
      createIdentifyEvent(identifiers.account.properties)
    );

  return amplitude;
};

const logEvent = async (event, eventProperties) => {
  if (!initPromise) return;
  await initPromise;
  amplitude.getInstance().logEvent(event, eventProperties);
};

const TrackingEvents = {
  CREATE_TEMPLATE: 'Create template',
  DELETE_TEMPLATE: 'Delete template',
  VIEW_TEMPLATES_PAGE: 'View templates page',
  VIEW_DASHBOARD: 'View dashboard',
  DELETE_RETROSPECTIVE: 'Delete retrospective',
  OPEN_RETROSPECTIVE: 'Open retrospective',
  EDIT_RETROSPECTIVE: 'Edit retrospective',
  CREATE_RETROSPECTIVE: 'Create retrospective',
  SEARCH_RETROSPECTIVES: 'Search retrospectives',
  CREATE_CARD: 'Create card',
  UPDATE_CARD: 'Update card',
  DELETE_CARD: 'Delete card',
  VOTE_CARD: 'Vote card',
  UNVOTE_CARD: 'Unvote card',
  GROUP_CARDS: 'Group cards',
  REORDER_CARD: 'Reorder card',
  ADD_RETROSPECTIVE_ACTION: 'Add retrospective action',
  CLICK_RETROSPECTIVE_ACTION: 'Click retrospective action',
  MOVE_TO_NEXT_STAGE: 'Move to next stage',
  MOVE_TO_PREVIOUS_STAGE: 'Move to previous stage',
  FINISH_RETROSPECTIVE: 'Finish retrospective',
  GO_BACK_TO_DASHBOARD: 'Go back to dashboard',
  START_TIMER: 'Start timer',
  STOP_TIMER: 'Stop timer',
  PAUSE_TIMER: 'Pause timer',
  CLICK_IM_FINISHED: `Click I'm finished`,
  EXPORT_RETROSPECTIVES: `Export retrospectives`,
};

export { initTracking, logEvent, TrackingEvents };
